import ApolloClient from "apollo-boost";
import urls from "../../configs/urls"
import { InMemoryCache } from 'apollo-cache-inmemory';

export default new ApolloClient({
  cache: new InMemoryCache(),
  uri: `${urls.api}graphql`,
  request: async operation => {
    operation.setContext({
      fetchOptions: {
        credentials: 'include'
      }
    });
  }
});


// WEBPACK FOOTER //
// ./src/store/graphql/index.js